import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-update-drive-time-popup b-blue-background b-blue-background__opacity b-blue-background--fixed" }
const _hoisted_2 = { class: "h-flex-dir-column h-flex-center" }
const _hoisted_3 = { class: "h-font-22 h-mb-0 h-text-center" }
const _hoisted_4 = { class: "b-update-drive-time-popup__text" }
const _hoisted_5 = { class: "b-update-drive-time-popup__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      iconColor: "#BEC7D4",
      "max-width": "400px",
      width: "auto",
      title: "",
      allowBackgroundScrolling: true,
      showClosePopup: true,
      popupBackground: "#F8F9FA",
      padding: "20px 30px",
      popupRadius: "20px",
      heightValue: "100%",
      onClose: _ctx.closePopup
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('CALENDAR.UPDATE_DRIVE_TIME')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('CALENDAR.UPDATE_DRIVE_TIME_TO')) + " " + _toDisplayString(_ctx.currentFormattedDate) + " ? ", 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FwButton, {
            class: "h-mt-10 h-flex-1-0 h-mh-10",
            borderRadiusType: "small-border",
            color: "alert",
            paddingHorizontal: true,
            onClick: _ctx.closePopup
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('AUTH.LOG_OUT.NO')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_FwButton, {
            class: "h-mt-10 h-flex-1-0 h-mh-10",
            paddingHorizontal: true,
            borderRadiusType: "small-border",
            onClick: _ctx.updateDriveTime
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('AUTH.LOG_OUT.YES')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["onClose"])
  ]))
}